var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/external-image-macro.j2"] = require( "macros/external-image-macro.j2" );
dependencies["macros/contentful-image-macro.j2"] = require( "macros/contentful-image-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/picture-element-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/external-image-macro.j2", false, "core/templates/macros/picture-element-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderExternalPictureElement")) {
var t_4 = t_1.renderExternalPictureElement;
} else {
cb(new Error("cannot import 'renderExternalPictureElement'")); return;
}
context.setVariable("renderExternalPictureElement", t_4);
env.getTemplate("macros/contentful-image-macro.j2", false, "core/templates/macros/picture-element-macro.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("renderContentfulPictureElement")) {
var t_8 = t_5.renderContentfulPictureElement;
} else {
cb(new Error("cannot import 'renderContentfulPictureElement'")); return;
}
context.setVariable("renderContentfulPictureElement", t_8);
var macro_t_9 = runtime.makeMacro(
["entry"], 
["isLazy", "experience"], 
function (l_entry, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", l_entry);
frame.set("isLazy", kwargs.hasOwnProperty("isLazy") ? kwargs["isLazy"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("experience", kwargs.hasOwnProperty("experience") ? kwargs["experience"] : {});
var t_10 = "";var t_11;
t_11 = (lineno = 13, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_entry,"fields"]));
frame.set("entryFields", t_11, true);
if(frame.topLevel) {
context.setVariable("entryFields", t_11);
}
if(frame.topLevel) {
context.addExport("entryFields", t_11);
}
t_10 += "\n\n    ";
var t_12;
t_12 = (lineno = 15, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"backgroundImage.fields.primaryImageLinkToExternalUrl",false]));
frame.set("primaryImageLinkToExternalUrl", t_12, true);
if(frame.topLevel) {
context.setVariable("primaryImageLinkToExternalUrl", t_12);
}
if(frame.topLevel) {
context.addExport("primaryImageLinkToExternalUrl", t_12);
}
t_10 += "\n\n    ";
t_10 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "primaryImageLinkToExternalUrl") || (lineno = 21, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"primaryImageLinkToExternalUrl"]))) {
t_10 += "\n\n        ";
t_10 += "\n        ";
var t_13;
t_13 = (runtime.contextOrFrameLookup(context, frame, "primaryImageLinkToExternalUrl")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entryFields")),"backgroundImage")),"fields"):runtime.contextOrFrameLookup(context, frame, "entryFields"));
frame.set("imageFields", t_13, true);
if(frame.topLevel) {
context.setVariable("imageFields", t_13);
}
if(frame.topLevel) {
context.addExport("imageFields", t_13);
}
t_10 += runtime.suppressValue((lineno = 31, colno = 37, runtime.callWrap(t_4, "renderExternalPictureElement", context, [l_entry,runtime.contextOrFrameLookup(context, frame, "imageFields"),runtime.contextOrFrameLookup(context, frame, "isLazy")])), env.opts.autoescape);
t_10 += "\n\n    ";
;
}
else {
if((lineno = 41, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"backgroundImage.fields.alternateImage.fields.file"]))) {
t_10 += "\n\n            ";
var t_14;
t_14 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"backgroundImage")),"fields")),"alternateImage");
frame.set("source_srcset", t_14, true);
if(frame.topLevel) {
context.setVariable("source_srcset", t_14);
}
if(frame.topLevel) {
context.addExport("source_srcset", t_14);
}
t_10 += "\n\n            ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"backgroundImage")),"fields")),"alternateImage")),"fields")),"file")),"contentType");
frame.set("srcset_type", t_15, true);
if(frame.topLevel) {
context.setVariable("srcset_type", t_15);
}
if(frame.topLevel) {
context.addExport("srcset_type", t_15);
}
t_10 += "\n\n        ";
;
}
else {
if((lineno = 47, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"alternateImage.fields.file"]))) {
t_10 += "\n\n            ";
var t_16;
t_16 = runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"alternateImage");
frame.set("source_srcset", t_16, true);
if(frame.topLevel) {
context.setVariable("source_srcset", t_16);
}
if(frame.topLevel) {
context.addExport("source_srcset", t_16);
}
t_10 += "\n\n            ";
var t_17;
t_17 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"alternateImage")),"fields")),"file")),"contentType");
frame.set("srcset_type", t_17, true);
if(frame.topLevel) {
context.setVariable("srcset_type", t_17);
}
if(frame.topLevel) {
context.addExport("srcset_type", t_17);
}
t_10 += "\n\n        ";
;
}
else {
if((lineno = 53, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"backgroundImage.fields.primaryImage.fields.file"]))) {
t_10 += "\n\n            ";
var t_18;
t_18 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"backgroundImage")),"fields")),"primaryImage");
frame.set("source_srcset", t_18, true);
if(frame.topLevel) {
context.setVariable("source_srcset", t_18);
}
if(frame.topLevel) {
context.addExport("source_srcset", t_18);
}
t_10 += "\n\n            ";
var t_19;
t_19 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"backgroundImage")),"fields")),"primaryImage")),"fields")),"file")),"contentType");
frame.set("srcset_type", t_19, true);
if(frame.topLevel) {
context.setVariable("srcset_type", t_19);
}
if(frame.topLevel) {
context.addExport("srcset_type", t_19);
}
t_10 += "\n\n        ";
;
}
else {
if((lineno = 59, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"primaryImage.fields.file"]))) {
t_10 += "\n\n            ";
var t_20;
t_20 = runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"primaryImage");
frame.set("source_srcset", t_20, true);
if(frame.topLevel) {
context.setVariable("source_srcset", t_20);
}
if(frame.topLevel) {
context.addExport("source_srcset", t_20);
}
t_10 += "\n\n            ";
var t_21;
t_21 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"primaryImage")),"fields")),"file")),"contentType");
frame.set("srcset_type", t_21, true);
if(frame.topLevel) {
context.setVariable("srcset_type", t_21);
}
if(frame.topLevel) {
context.addExport("srcset_type", t_21);
}
t_10 += "\n\n        ";
;
}
else {
t_10 += "\n\n            ";
var t_22;
t_22 = true;
frame.set("hidePictureElement", t_22, true);
if(frame.topLevel) {
context.setVariable("hidePictureElement", t_22);
}
if(frame.topLevel) {
context.addExport("hidePictureElement", t_22);
}
t_10 += "\n\n        ";
;
}
;
}
;
}
;
}
if((lineno = 77, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"backgroundImage.fields.primaryImage"]))) {
t_10 += "\n\n            ";
var t_23;
t_23 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"backgroundImage")),"fields")),"primaryImage");
frame.set("imgsrc", t_23, true);
if(frame.topLevel) {
context.setVariable("imgsrc", t_23);
}
if(frame.topLevel) {
context.addExport("imgsrc", t_23);
}
t_10 += "\n\n            ";
var t_24;
t_24 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"backgroundImage")),"fields")),"alternateText");
frame.set("altText", t_24, true);
if(frame.topLevel) {
context.setVariable("altText", t_24);
}
if(frame.topLevel) {
context.addExport("altText", t_24);
}
t_10 += "\n\n            ";
var t_25;
t_25 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"backgroundImage")),"fields")),"primaryImage")),"fields")),"file")),"contentType");
frame.set("imgSrc_type", t_25, true);
if(frame.topLevel) {
context.setVariable("imgSrc_type", t_25);
}
if(frame.topLevel) {
context.addExport("imgSrc_type", t_25);
}
t_10 += "\n\n\n        ";
;
}
else {
if((lineno = 86, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"primaryImage.fields.file"]))) {
t_10 += "\n\n            ";
var t_26;
t_26 = runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"primaryImage");
frame.set("imgsrc", t_26, true);
if(frame.topLevel) {
context.setVariable("imgsrc", t_26);
}
if(frame.topLevel) {
context.addExport("imgsrc", t_26);
}
t_10 += "\n\n            ";
var t_27;
t_27 = runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"alternateText");
frame.set("altText", t_27, true);
if(frame.topLevel) {
context.setVariable("altText", t_27);
}
if(frame.topLevel) {
context.addExport("altText", t_27);
}
t_10 += "\n\n            ";
var t_28;
t_28 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"primaryImage")),"fields")),"file")),"contentType");
frame.set("imgSrc_type", t_28, true);
if(frame.topLevel) {
context.setVariable("imgSrc_type", t_28);
}
if(frame.topLevel) {
context.addExport("imgSrc_type", t_28);
}
t_10 += "\n\n        ";
;
}
;
}
t_10 += "\n        ";
if((lineno = 102, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"primaryImageQuality"]))) {
t_10 += "\n\n            ";
var t_29;
t_29 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "experience")),"reduced")?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "experience")),"image_quality"):runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"primaryImageQuality"));
frame.set("primaryImageQuality", t_29, true);
if(frame.topLevel) {
context.setVariable("primaryImageQuality", t_29);
}
if(frame.topLevel) {
context.addExport("primaryImageQuality", t_29);
}
t_10 += "\n\n        ";
;
}
else {
t_10 += "\n\n            ";
var t_30;
t_30 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "experience")),"image_quality");
frame.set("primaryImageQuality", t_30, true);
if(frame.topLevel) {
context.setVariable("primaryImageQuality", t_30);
}
if(frame.topLevel) {
context.addExport("primaryImageQuality", t_30);
}
t_10 += "\n\n        ";
;
}
t_10 += "\n\n        ";
if((lineno = 112, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entryFields"),"alternateImageQuality"]))) {
t_10 += "\n\n            ";
var t_31;
t_31 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "experience")),"reduced")?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "experience")),"image_quality"):runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"alternateImageQuality"));
frame.set("alternateImageQuality", t_31, true);
if(frame.topLevel) {
context.setVariable("alternateImageQuality", t_31);
}
if(frame.topLevel) {
context.addExport("alternateImageQuality", t_31);
}
t_10 += "\n\n        ";
;
}
t_10 += "\n\n        ";
if(!runtime.contextOrFrameLookup(context, frame, "hidePictureElement")) {
t_10 += runtime.suppressValue((lineno = 124, colno = 39, runtime.callWrap(t_8, "renderContentfulPictureElement", context, [l_entry,runtime.contextOrFrameLookup(context, frame, "altText"),runtime.contextOrFrameLookup(context, frame, "isLazy"),runtime.contextOrFrameLookup(context, frame, "source_srcset"),runtime.contextOrFrameLookup(context, frame, "imgsrc"),runtime.contextOrFrameLookup(context, frame, "alternateImageQuality"),runtime.contextOrFrameLookup(context, frame, "primaryImageQuality"),runtime.contextOrFrameLookup(context, frame, "imgSrc_type"),runtime.contextOrFrameLookup(context, frame, "srcset_type")])), env.opts.autoescape);
t_10 += "\n\n        ";
;
}
t_10 += "\n\n    ";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("pictureElement");
context.setVariable("pictureElement", macro_t_9);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/picture-element-macro.j2"] , dependencies)